export default __webpack_public_path__ + "static/media/MONO.7c5472dd.ttf";